/* Buscador de consumibles y recambios compatibles.
 *
 * Todo en el navegador, sin backend:
 *   1. /search/suggest.json          -> encuentra la referencia por modelo o SKU
 *   2. /products/<handle>?view=compatibles -> sus accesorios y consumibles
 *
 * El paso 2 es una plantilla alterna del tema que devuelve JSON
 * (templates/product.compatibles.liquid). Asi el dato es el MISMO que pinta la
 * ficha y no hay ningun catalogo copiado en este fichero que pueda quedarse
 * viejo, que es el criterio que ya se siguio con el asistente de eleccion.
 *
 * POR REFERENCIA, NO POR FAMILIA. La compatibilidad se guarda por unidad: la
 * ZD421 se vende en termica directa y en transferencia termica, y la de directa
 * no lleva ribbon. Por eso cuando la busqueda da varias referencias del mismo
 * modelo se pregunta cual, en vez de mezclarlas.
 */
(function () {
  'use strict';

  var raiz = document.querySelector('[data-bc]');
  if (!raiz) return;

  var form = raiz.querySelector('#bc-form');
  var campo = raiz.querySelector('#bc-q');
  var aviso = raiz.querySelector('#bc-aviso');
  var refs = raiz.querySelector('#bc-refs');
  var lista = raiz.querySelector('#bc-lista');
  var pista = raiz.querySelector('#bc-pista');
  var salida = raiz.querySelector('#bc-salida');
  var cargando = raiz.querySelector('#bc-cargando');

  // El escaparate limita las peticiones, y MUCHO antes de lo que parecia: la
  // primera version pedia las 6 fichas A LA VEZ y eso basta para que Shopify
  // empiece a responder 429 -o, peor, un 200 cuyo cuerpo no es nuestro JSON-.
  // Con eso el buscador moria con "Cannot read properties of undefined".
  //
  // Ahora se piden DE UNA EN UNA, con una pausa entre medias, y se para en
  // cuanto hay suficientes. El caso normal es 1-2 peticiones, no 6.
  var MAX_CANDIDATOS = 5;   // como mucho se consultan estas
  var SUFICIENTES = 4;      // y se para al reunir estas con datos
  var PAUSA = 150;          // ms entre consultas
  var cache = {};

  // Orden de grupos escrito a mano, el mismo de snippets/compatibles.liquid:
  // manda el criterio de compra -primero cabezales y etiquetas, al final
  // repuestos- y no el alfabetico.
  var ORDEN_ACC = ['Cabezales de impresión', 'Baterías y carga',
    'Cables y conectividad', 'Soportes y montaje', 'Fundas y protección',
    'Teclados y periféricos', 'Rodillos y platina',
    'Cortadores y dispensadores', 'Piezas de repuesto', 'Otros'];
  var ORDEN_CON = ['Etiquetas', 'Ribbons y cintas', 'Tóner y tinta',
    'Papel y recibos', 'Pulseras', 'Tarjetas', 'Otros'];

  function euros(centimos) {
    return (centimos / 100).toLocaleString('es-ES',
      { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }

  function decir(texto, esError) {
    aviso.textContent = texto || '';
    aviso.hidden = !texto;
    aviso.classList.toggle('bc__aviso--error', !!esError);
  }

  function limpiar() {
    salida.innerHTML = '';
    refs.hidden = true;
    lista.innerHTML = '';
  }

  function esperar(ms) {
    return new Promise(function (r) { setTimeout(r, ms); });
  }

  /* SIN cabecera Accept, y esto NO es un descuido: es la causa de que el
     buscador no encontrara nada.

     Con `Accept: application/json`, Shopify IGNORA el `?view=` y contesta con
     SU propio JSON. Comprobado:

       /collections/honeywell-pm45?view=compatibles
         sin Accept  -> {handle, titulo, es_modelo, modelo, total, referencias}
         con Accept  -> {collection: {...}}          <- el de Shopify

     Como el nuestro nunca llegaba, `es_modelo` salia undefined y la busqueda
     caia siempre al respaldo; y antes de eso, `x.accesorios.length` reventaba
     sobre undefined. Las dos averias tenian esta misma raiz.

     Y no se vio en semanas de comprobaciones porque `curl` no manda esa
     cabecera: LAS PRUEBAS HACIAN UNA PETICION DISTINTA DE LA DEL CODIGO. */
  function pedir(url, reintentos) {
    reintentos = reintentos == null ? 1 : reintentos;
    return fetch(url)
      .then(function (r) {
        // 429/430 son "vas demasiado rapido", no "no existe". Se reintenta una
        // vez tras una pausa y, si sigue, se marca para poder decirselo al
        // visitante con esas palabras en vez de con un error tecnico.
        if (r.status === 429 || r.status === 430) {
          if (reintentos > 0) {
            return esperar(1200).then(function () { return pedir(url, reintentos - 1); });
          }
          var e = new Error('throttle');
          e.throttle = true;
          throw e;
        }
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      });
  }

  // Que la respuesta tenga de verdad NUESTRA forma. Cuando el escaparate va
  // apretado devuelve a veces un 200 con otro cuerpo, y dar por hecho que ahi
  // venian `accesorios` y `consumibles` es lo que rompia el buscador entero.
  function esFicha(d) {
    return !!d && Object.prototype.toString.call(d.accesorios) === '[object Array]'
      && Object.prototype.toString.call(d.consumibles) === '[object Array]';
  }

  function compatiblesDe(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return pedir('/products/' + encodeURIComponent(handle) + '?view=compatibles')
      .then(function (d) {
        if (!esFicha(d)) return null;
        cache[handle] = d;
        return d;
      });
  }

  /* Consulta las fichas UNA A UNA y para en cuanto tiene suficientes.
     Devuelve {datos, cortado} — `cortado` avisa de que el escaparate nos
     freno, para no presentar una lista incompleta como si fuera toda. */
  function recolectar(productos) {
    var out = [];
    var i = 0;
    function paso() {
      if (i >= productos.length || i >= MAX_CANDIDATOS || out.length >= SUFICIENTES) {
        return Promise.resolve({ datos: out, cortado: false });
      }
      var p = productos[i++];
      return compatiblesDe(p.handle).then(function (d) {
        if (d && (d.accesorios.length || d.consumibles.length)) out.push(d);
        return esperar(PAUSA).then(paso);
      }, function (e) {
        if (e && e.throttle) return { datos: out, cortado: true };
        return esperar(PAUSA).then(paso);   // un fallo suelto no para la busqueda
      });
    }
    return paso();
  }

  /* PRIMERO se intenta resolver el MODELO por su coleccion, y solo si no hay
     se cae a la busqueda de productos.

     La razon: la busqueda predictiva ordena por relevancia de texto, y hay
     muchos mas accesorios que nombran un modelo que unidades. Buscando `PM45`
     los cinco primeros productos son un adaptador, un rebobinador, un modulo
     de interfaz, un modulo de cinta y una guia de borde -ninguno con
     compatibles-, asi que el buscador decia "no hay nada" teniendo las 36
     impresoras PM45 en catalogo.

     La coleccion de modelo contiene EXACTAMENTE las unidades, asi que una
     peticion da todas sus referencias en vez de las que el texto puso arriba. */
  function buscar(consulta) {
    limpiar();
    decir('');
    cargando.hidden = false;

    var urlCol = '/search/suggest.json?q=' + encodeURIComponent(consulta) +
      '&resources[type]=collection&resources[limit]=5';

    pedir(urlCol).then(function (d) {
      var cols = (d.resources && d.resources.results &&
        d.resources.results.collections) || [];
      if (!cols.length) return null;
      return pedir('/collections/' + encodeURIComponent(cols[0].handle) +
        '?view=compatibles').then(function (c) {
          // Ademas de `es_modelo`, un tope de tamano. No es redundante: cuando
          // se cambia la plantilla, Shopify sirve la version vieja desde la
          // cache de borde durante un rato -medido: 1 de cada 6 respuestas-, y
          // aquella daba `es_modelo` mirando solo el primer producto, con lo
          // que `impresoras-1` (629 productos) pasaba el filtro. Una familia
          // de modelo no llega a 60 referencias ni de lejos.
          var ok = c && c.es_modelo === true && c.referencias &&
            c.referencias.length && (c.total || 0) <= 60;
          return ok ? c : null;
        }, function () { return null; });
    }, function () { return null; })
      .then(function (col) {
        if (col) return porColeccion(col);
        return porProducto(consulta);
      })
      .catch(function (e) {
        cargando.hidden = true;
        decir(e && e.throttle
          ? 'La tienda está recibiendo muchas consultas ahora mismo. Espera unos ' +
            'segundos y vuelve a buscar.'
          : 'No he podido consultar la tienda (' + e.message + '). ' +
            'Vuelve a intentarlo en unos segundos.', true);
      });
  }

  /* Camino bueno: tenemos la coleccion del modelo y con ella TODAS sus
     referencias. La ficha de cada una se pide solo al seleccionarla, asi que
     una busqueda son 3 peticiones y no 6. */
  function porColeccion(col) {
    cargando.hidden = true;
    pintarReferencias(col.referencias.map(function (r) {
      return { handle: r.handle, titulo: r.titulo, sku: r.sku, pendiente: true };
    }), col);
    return seleccionar({ handle: col.referencias[0].handle });
  }

  function porProducto(consulta) {
    var url = '/search/suggest.json?q=' + encodeURIComponent(consulta) +
      '&resources[type]=product&resources[limit]=10' +
      '&resources[options][unavailable_products]=show' +
      '&resources[options][fields]=title,vendor,product_type,variants.sku';

    return pedir(url).then(function (d) {
      var productos = (d.resources && d.resources.results &&
        d.resources.results.products) || [];
      if (!productos.length) {
        cargando.hidden = true;
        decir('No he encontrado ningún equipo con «' + consulta + '». Prueba con ' +
          'el modelo (ZD621, MC9300) o con la referencia exacta que aparece en ' +
          'la etiqueta del aparato.', true);
        return;
      }
      return recolectar(productos).then(function (r) {
        cargando.hidden = true;
        var conDatos = r.datos;
        if (!conDatos.length) {
          decir(r.cortado
            ? 'La tienda está recibiendo muchas consultas ahora mismo. Espera ' +
              'unos segundos y vuelve a buscar.'
            : 'He encontrado el producto, pero todavía no tiene accesorios ni ' +
              'consumibles asociados en la tienda. Escríbenos y te decimos qué ' +
              'le corresponde.', true);
          return;
        }
        if (r.cortado) {
          decir('La tienda va justa de consultas, así que puede que falte alguna ' +
            'referencia en la lista. Vuelve a buscar en unos segundos para verlas ' +
            'todas.');
        }
        pintarReferencias(conDatos.map(function (d) {
          return { handle: d.handle, titulo: d.titulo, sku: d.sku,
                   acc: d.accesorios.length, con: d.consumibles.length };
        }));
        seleccionar({ handle: conDatos[0].handle });
      });
    });
  }

  function pintarReferencias(items, col) {
    lista.innerHTML = '';
    items.forEach(function (d) {
      var li = document.createElement('li');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'bc__ref';
      b.setAttribute('aria-pressed', 'false');
      b.dataset.handle = d.handle;

      var n = document.createElement('span');
      n.className = 'bc__ref-nombre';
      n.textContent = d.titulo;

      var s = document.createElement('span');
      s.className = 'bc__ref-datos';
      // Viniendo de la coleccion no se han pedido las fichas todavia, asi que
      // no hay recuentos: se ensena la referencia y ya. Es preferible a hacer
      // 36 peticiones para poner un numero al lado de cada boton.
      s.textContent = d.pendiente
        ? (d.sku ? 'Ref. ' + d.sku : 'Ver sus compatibles')
        : (d.sku ? 'Ref. ' + d.sku + ' · ' : '') +
          d.acc + ' accesorios · ' + d.con + ' consumibles';

      b.appendChild(n);
      b.appendChild(s);
      b.addEventListener('click', function () { seleccionar(d); });
      li.appendChild(b);
      lista.appendChild(li);
    });

    var t = refs.querySelector('h2');
    if (t) {
      t.textContent = col
        ? 'Referencias de ' + (col.modelo || col.titulo) + ' (' + items.length + ')'
        : 'Referencias encontradas';
    }
    // Solo tiene sentido explicar la eleccion si de verdad hay que elegir.
    pista.hidden = items.length < 2;
    refs.hidden = false;
  }

  /* La ficha se pide AQUI, al seleccionar, no al listar. Asi una busqueda son
     3 peticiones aunque el modelo tenga 36 referencias. */
  function seleccionar(d) {
    lista.querySelectorAll('.bc__ref').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.dataset.handle === d.handle));
    });
    salida.innerHTML = '';
    cargando.hidden = false;
    return compatiblesDe(d.handle).then(function (ficha) {
      cargando.hidden = true;
      if (!ficha) {
        decir('No he podido leer los compatibles de esa referencia. ' +
          'Prueba con otra o vuelve a intentarlo.', true);
        return;
      }
      if (!ficha.accesorios.length && !ficha.consumibles.length) {
        decir('Esta referencia todavía no tiene accesorios ni consumibles ' +
          'asociados. Prueba con otra de la lista, o escríbenos y te decimos ' +
          'qué le corresponde.', true);
        return;
      }
      decir('');
      pintarResultado(ficha);
    }, function (e) {
      cargando.hidden = true;
      decir(e && e.throttle
        ? 'La tienda está recibiendo muchas consultas ahora mismo. Espera unos ' +
          'segundos y vuelve a pinchar la referencia.'
        : 'No he podido leer esa referencia (' + e.message + ').', true);
    });
  }

  function pintarResultado(d) {
    salida.innerHTML = '';

    var cab = document.createElement('div');
    cab.className = 'bc__equipo';
    if (d.imagen) {
      var img = document.createElement('img');
      img.src = d.imagen;
      img.alt = '';
      img.loading = 'lazy';
      cab.appendChild(img);
    }
    var caja = document.createElement('div');
    var h = document.createElement('p');
    h.className = 'bc__equipo-nombre';
    h.textContent = d.titulo;
    var sub = document.createElement('p');
    sub.className = 'bc__equipo-datos';
    var partes = [];
    if (d.sku) partes.push('Referencia ' + d.sku);
    if (d.modelo) partes.push('Modelo ' + d.modelo);
    partes.push(d.accesorios.length + ' accesorios');
    partes.push(d.consumibles.length + ' consumibles');
    sub.textContent = partes.join(' · ');
    caja.appendChild(h);
    caja.appendChild(sub);
    cab.appendChild(caja);
    salida.appendChild(cab);

    bloque('Consumibles compatibles', d.consumibles, ORDEN_CON);
    bloque('Accesorios y recambios compatibles', d.accesorios, ORDEN_ACC);

    var pie = document.createElement('p');
    pie.className = 'bc__aviso';
    pie.innerHTML = 'Precios sin IVA. Lo que aparece agotado se sirve bajo ' +
      'pedido al fabricante en unas 4 semanas: pídelo desde su ficha con ' +
      '«Solicitar presupuesto». ¿No ves lo que buscas? ' +
      '<a href="/pages/contacto">Escríbenos</a> con la referencia de tu equipo.';
    salida.appendChild(pie);

    function bloque(titulo, items, orden) {
      if (!items.length) return;
      var sec = document.createElement('section');
      sec.className = 'bc__bloque';
      var t = document.createElement('h2');
      t.textContent = titulo + ' (' + items.length + ')';
      sec.appendChild(t);

      // Se recorre el orden escrito a mano y, al final, lo que no encaje en
      // ningun grupo conocido: si manana aparece un grupo nuevo, sale igual en
      // vez de desaparecer sin avisar.
      var pendientes = items.slice();
      orden.concat(['__resto__']).forEach(function (g) {
        var deGrupo;
        if (g === '__resto__') {
          deGrupo = pendientes.slice();
        } else {
          deGrupo = pendientes.filter(function (x) { return x.grupo === g; });
        }
        if (!deGrupo.length) return;
        pendientes = pendientes.filter(function (x) {
          return deGrupo.indexOf(x) === -1;
        });
        var dg = document.createElement('div');
        dg.className = 'bc__grupo';
        var h3 = document.createElement('h3');
        h3.textContent = (g === '__resto__' ? 'Otros' : g) + ' (' + deGrupo.length + ')';
        dg.appendChild(h3);
        var ul = document.createElement('ul');
        ul.className = 'bc__items';
        deGrupo.forEach(function (x) { ul.appendChild(item(x)); });
        dg.appendChild(ul);
        sec.appendChild(dg);
      });
      salida.appendChild(sec);
    }

    function item(x) {
      var li = document.createElement('li');
      li.className = 'bc__item';
      if (x.imagen) {
        var im = document.createElement('img');
        im.src = x.imagen;
        im.alt = '';
        im.loading = 'lazy';
        li.appendChild(im);
      }
      var caja = document.createElement('div');
      var a = document.createElement('a');
      a.className = 'bc__item-nombre';
      a.href = x.url;
      a.textContent = x.titulo;
      caja.appendChild(a);
      if (x.sku) {
        var s = document.createElement('span');
        s.className = 'bc__item-sku';
        s.textContent = 'Ref. ' + x.sku;
        caja.appendChild(s);
      }
      if (x.precio) {
        var p = document.createElement('span');
        p.className = 'bc__item-precio';
        p.textContent = euros(x.precio);
        caja.appendChild(p);
      }
      var e = document.createElement('span');
      e.className = 'bc__estado';
      e.textContent = x.disponible ? 'En stock' : 'Bajo pedido · ~4 semanas';
      caja.appendChild(e);
      li.appendChild(caja);
      return li;
    }
  }

  form.addEventListener('submit', function (ev) {
    ev.preventDefault();
    var q = campo.value.trim();
    if (q.length < 2) {
      decir('Escribe al menos dos caracteres.', true);
      return;
    }
    buscar(q);
  });

  raiz.querySelectorAll('.bc__ejemplo').forEach(function (b) {
    b.addEventListener('click', function () {
      campo.value = b.textContent;
      buscar(b.textContent);
    });
  });

  // ?q=PM45 busca al entrar. Sirve para enlazar una busqueda concreta -desde
  // una ficha, un correo o una guia- y, de paso, es la unica forma de probar
  // esta pagina de punta a punta contra la tienda de verdad, sin simular la
  // red: con `fetch` simulado los fallos del entorno real no aparecen.
  var q0 = (location.search.match(/[?&]q=([^&]*)/) || [])[1];
  if (q0) {
    q0 = decodeURIComponent(q0.replace(/\+/g, ' ')).trim();
    if (q0.length >= 2) {
      campo.value = q0;
      buscar(q0);
    }
  }
})();
